import { useContext } from "react"
import { DadosPedidoFornecedorContext } from "./DadosPedidoFornecedorContext"

export function useDadosPedidoFornecedorContext() {
    return useContext(DadosPedidoFornecedorContext)
}
